import { Injectable } from '@angular/core';
import { IPackage } from '@models';
import { ODataQueryOptions } from '@services/generics/odata.query';
import { PackageService } from '@services/package.service';
import {
    IPackageDataSource,
    Package,
    PackageList,
    PackageStatus,
} from '@uipath/workflow-web-viewer';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Service for package viewer
 */
@Injectable({
    providedIn: 'root',
})
export class NugetViewerService implements IPackageDataSource {

    constructor(
        private readonly _packageService: PackageService,
    ) { }

    /**
     * Fetches a collection of package viewer details for a specific package
     * @param packageName Package Id
     * @param pageNumber Package version
     * @param pageSize Number of items to fetch at once
     */
    fetchPackageVersions = (
        packageName: string,
        pageNumber: number,
        pageSize: number,
    ): Observable<PackageList> => {
        const queryOptions: ODataQueryOptions = {
            top: pageSize,
            skip: pageSize * (pageNumber - 1),
        };

        return this._packageService.getVersions(packageName, queryOptions).pipe(
            map((response) => {
                    const packageList = response.data.map((iPackage: IPackage) => {
                        return new Package(
                            iPackage.id,
                            iPackage.version,
                            iPackage.description,
                            iPackage.authors,
                            iPackage.published.toLocaleDateString(),
                            iPackage.releaseNotes,
                            iPackage.isActive ? PackageStatus.Active : PackageStatus.InActive,
                        );
                });

                return new PackageList(packageList, response.total);
            }),
        );
    }

    /**
     * Downloads a package file data as blob
     * @param packageName Package Id
     * @param packageVersion Package version
     */
    downloadPackage = (
        packageName: string,
        packageVersion: string,
    ): Observable<Blob> => {
        return this._packageService.download(packageName + ':' + packageVersion)
            .pipe(
                map(
                    (buffer) => {
                        return new Blob([buffer]);
                    },
                ),
            );
    }
}
